import { ACTION_FABRIC_LIBRARY_VISIBILITY, ADD_FABRIC_LIST } from "./actions"

export interface IFabricTile {
    name: string,
    shortDescription: { html: string },
    image: string,
    specialPrice: { html: string },
    width: number,
    price: number,
    adjustedPrice: number,
    pUrl: string,
    currency: string,
    totalLength: number,
    productID: number,
    sample2: string,
    orderOptions: any []
}

export interface IFabricLibrary {
    displayFabricLibrary?: boolean,
    tiles?: IFabricTile[]
}

const parseTileList = (tiles:IFabricTile[]=[])=> tiles.map(fabric => ({
    name: fabric.name,
    shortDescription: { html: fabric.shortDescription },
    image: fabric.image,
    specialPrice: { html: fabric.specialPrice },
    width: fabric.width,
    price: parseFloat(''+fabric.price),
    adjustedPrice: parseFloat(''+fabric.adjustedPrice),
    pUrl: fabric.pUrl,
    currency: fabric.currency,
    totalLength: fabric.totalLength,
    productID: fabric.productID,
    sample2: fabric.sample2,
    orderOptions: fabric.orderOptions
}))

export const fabricLibrary = (state = {}, action: any) => {
    switch (action.type) {
        case ACTION_FABRIC_LIBRARY_VISIBILITY:
            return { ...state, displayFabricLibrary: action.payload.visible, selOptionType: action.payload.selOptionType, parentWindowScroll:action.payload.parentWindowScroll }
        case ADD_FABRIC_LIST:
            return {...state, tiles: parseTileList(action.payload.theFabricList) }
        default:
            return state
    }
}